// const requiredPermissionsForLoanOfficer = [
//   'create:loan',
//   'get:lead',
//   'update:loan',
// ];
// const requiredPermissionsForConsumer = ['create:loan', 'update:loan'];
// const requiredPermissionsForOrganization = [
//   'create:loan',
//   'get:lead',
//   'get:reports',
//   'update:loan',
// ];

// export const hasPermissions = (permissions = [], userType) => {
//   const checkExactPermissions = (requiredPermissions) => {
//     return (
//       permissions.length === requiredPermissions.length &&
//       requiredPermissions.every((permission) =>
//         permissions.includes(permission)
//       )
//     );
//   };

//   switch (userType) {
//     case 'consumer':
//       return checkExactPermissions(requiredPermissionsForConsumer);
//     case 'loanOfficer':
//       return checkExactPermissions(requiredPermissionsForLoanOfficer);
//     case 'organization':
//       return checkExactPermissions(requiredPermissionsForOrganization);
//     default:
//       return false;
//   }
// };

const requiredPermissionsForLoanOfficer = [
  'create:loan',
  'get:lead',
  'update:loan',
];
const requiredPermissionsForConsumer = ['create:loan', 'update:loan'];
const requiredPermissionsForOrganization = [
  'create:loan',
  'get:lead',
  'get:reports',
  'update:loan',
];

//Branch admin
const requiredPermissionsForBranchAdmin = [
  'create:loan',
  'update:loan',
  'delete:loan',
  'get:lead',
  'get:reports',
];

//Super Admin
const requiredPermissionsForSuperAdmin = [
  'create:loan',
  'update:loan',
  'delete:loan',
  'get:lead',
  'get:reports',
  'manage:branch',
];

//Loan Processor
const requiredPermissionsForLoanProcessor = [
  'get:loan',
  'get:lead',
  'get:reports',
];

export const hasPermissions = (permissions = [], userType) => {
  const checkExactPermissions = (requiredPermissions) => {
    return (
      permissions.length === requiredPermissions.length &&
      requiredPermissions.every((permission) =>
        permissions.includes(permission)
      )
    );
  };

  switch (userType) {
    case 'consumer':
      return checkExactPermissions(requiredPermissionsForConsumer);
    case 'loanOfficer':
      return checkExactPermissions(requiredPermissionsForLoanOfficer);
    case 'organization':
      return checkExactPermissions(requiredPermissionsForOrganization);
    case 'branchAdmin':
      return checkExactPermissions(requiredPermissionsForBranchAdmin);
    case 'superAdmin':
      return checkExactPermissions(requiredPermissionsForSuperAdmin);
    case 'loanProcessor':
      return checkExactPermissions(requiredPermissionsForLoanProcessor);
    default:
      return false;
  }
};
